export default __webpack_public_path__ + "static/media/github-pull-req.0e728877.svg";